import { getTimeAgoFormatted } from '@/shared/utils/getTimeAgoFormatted'
import { getTimeLeftFormatted } from '@/shared/utils/getTimeLeftFormatted'
import { ReactElement, useEffect, useState } from 'react'

type Props = {
  title: string | ReactElement | null
  icon: ReactElement
  subtitle: string | ReactElement | null
  timeLeft?: string
  fulfillTime?: number
  timeAgo?: string
  statusForTime?: 'pending' | 'inProgress' | 'appeals' | 'canceled' | 'completed' | 'none'
  titleClasses?: string
  subtitleClasses?: string
}

export const ItemLayout = ({
  subtitle,
  icon,
  title,
  timeLeft,
  fulfillTime,
  timeAgo,
  statusForTime,
  titleClasses = '',
  subtitleClasses = '',
}: Props) => {
  const [, setTick] = useState(0)

  // Update every minute
  useEffect(() => {
    const interval = setInterval(() => {
      setTick((prev) => prev + 1)
    }, 60_000)

    return () => clearInterval(interval)
  }, [])

  const timeClasses = {
    pending: 'text-warning',
    inProgress: 'text-primary',
    appeals: 'text-error',
    canceled: '',
    completed: '',
    none: '',
  }[statusForTime || 'none']

  return (
    <div className="flex items-center gap-2 md:gap-[10px]">
      <div>{icon}</div>
      <div className="flex flex-col">
        <div>
          <span className={`font-klein font-medium text-sm ${titleClasses}`}>{title ?? ''}</span>
          {timeAgo && statusForTime !== 'canceled' && statusForTime !== 'completed' && (
            <span className={`${timeClasses} font-klein font-medium`}>
              {getTimeAgoFormatted(timeAgo)}
            </span>
          )}
          {timeLeft && statusForTime !== 'canceled' && statusForTime !== 'completed' && (
            <span className={`${timeClasses} font-klein font-medium`}>
              {fulfillTime
                ? getTimeLeftFormatted({ createdAt: timeLeft, durationMinutes: fulfillTime })
                : getTimeLeftFormatted({ payingAllowedTill: timeLeft })}
            </span>
          )}
        </div>
        <span className={`text-text-secondary text-sm ${subtitleClasses}`}>{subtitle ?? ''}</span>
      </div>
    </div>
  )
}
